import { Component } from '@angular/core';

@Component({
  selector: 'mg-loader-overlay',
  templateUrl: './LoaderOverlay.component.html',
  styleUrls: ['./LoaderOverlay.component.scss'],
})
export class LoaderOverlayComponent {}
